function isWebGL2Ctx(gl) {
    return gl.getParameter(gl.VERSION).includes('WebGL 2.0');
}
export { isWebGL2Ctx };
